import i18next from 'i18next';

export const uiI18n = i18next.createInstance();
export const contentI18n = i18next.createInstance();

const baseConfig = {
  fallbackLng: 'he',
  interpolation: {
    escapeValue: false,
    prefix: '{',
    suffix: '}'
  },
  returnNull: false,
  returnEmptyString: false
};

void uiI18n.init(baseConfig);
void contentI18n.init(baseConfig);
